import { atom } from "recoil";
import localStorageEffect from "./util";

export const qrInfo = atom<any>({
  key: "qrInfoState",
  default: null,
  effects: [localStorageEffect("qr_info")],
});
